// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import customerReducer from './slices/customer';
import kilnReducer from './slices/kiln';
import steepReducer from './slices/steep';
import germReducer from './slices/germ';
import roastReducer from './slices/roast';
import inventoryReducer from './slices/inventory';
import prodOrderReducer from './slices/prodorder';
import contactReducer from './slices/contact';
import productReducer from './slices/product';
import chatReducer from './slices/chat';
import calendarReducer from './slices/calendar';
import mailReducer from './slices/mail';
import userReducer from './slices/user';
import cartReducer from './slices/cart';
import kanbanReducer from './slices/kanban';
import menuReducer from './slices/menu';
import utilsReducer from './slices/utils';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    cart: persistReducer(
        {
            key: 'cart',
            storage,
            keyPrefix: 'berry-'
        },
        cartReducer
    ),
    kanban: kanbanReducer,
    customer: customerReducer,
    kiln: kilnReducer,
    steep: steepReducer,
    germ: germReducer,
    roast: roastReducer,
    inventory: inventoryReducer,
    contact: contactReducer,
    product: productReducer,
    chat: chatReducer,
    calendar: calendarReducer,
    mail: mailReducer,
    user: userReducer,
    menu: menuReducer,
    prodorder: prodOrderReducer,
    fumesUtils: utilsReducer,
});

export default reducer;
